import axios from "axios";
import { getBaseUrl } from "../environment-url";
const CATALOG_API = axios.create({
  baseURL: getBaseUrl(process.env.REACT_APP_NODE_ENV, "SAP_CATALOG"),
  responseType: "json",
  withCredentials: false,
  timeout: 10000, // 10 seconds
});
//Add a response interceptor
CATALOG_API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("***********Unauthorized Error**********");
    }
    return Promise.reject(error);
  }
);
export default CATALOG_API ;